import api from '../axios';

export const get_banks = async () => {
  try {
    const response = await api.get('/type-bank');
    return response.data;
  } catch (error) {
    console.error('Error fetching banks:', error);
    return null;
  }
};

export const post_bank = async (data) => {
  try {
    const response = await api.post('/type-bank', data);
    return response.data;
  } catch (error) {
    console.error('Error creating bank:', error);
    return null;
  }
};

export const update_bank = async (data) => {
  try {
    const id = data._id || data.id;
    const response = await api.patch(`/type-bank/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating bank:', error);
    return null;
  }
};

export const delete_bank = async (data) => {
  try {
    const id = data._id || data.id;
    const response = await api.delete(`/type-bank/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting bank:', error);
    return null;
  }
};
